!function () {
  try {
    return new MouseEvent("test");
  } catch (e) {}
  var e = function e(_e, t) {
    t = t || {
      bubbles: !1,
      cancelable: !1
    };
    var n = document.createEvent("MouseEvent");
    return n.initMouseEvent(_e, t.bubbles, t.cancelable, window, 0, t.screenX || 0, t.screenY || 0, t.clientX || 0, t.clientY || 0, t.ctrlKey || !1, t.altKey || !1, t.shiftKey || !1, t.metaKey || !1, t.button || 0, t.relatedTarget || null), n;
  };
  e.prototype = Event.prototype, window.MouseEvent = e;
}();